import "core-js/modules/es6.string.small";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';

const GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'LandingImageText',
  components: {
    GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;

      return {
        richText: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.rich_text : _ref13 : _ref13) || [],
        image: {
          small: formatPrismicImage((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.image) != null ? (_ref12 = _ref12.small) != null ? _ref12.url : _ref12 : _ref12 : _ref12 : _ref12) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.image) != null ? (_ref11 = _ref11.medium) != null ? _ref11.url : _ref11 : _ref11 : _ref11 : _ref11) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? (_ref10 = _ref10.image) != null ? (_ref10 = _ref10.large) != null ? _ref10.url : _ref10 : _ref10 : _ref10 : _ref10) || EMPTY_PIXEL,
          xlarge: formatPrismicImage((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.image) != null ? (_ref9 = _ref9.xlarge) != null ? _ref9.url : _ref9 : _ref9 : _ref9 : _ref9) || EMPTY_PIXEL,
          alt: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.alt : _ref8 : _ref8) || ''
        },
        button: {
          bg_color: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.button_color : _ref7 : _ref7) || '',
          text_color: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.button_text_color : _ref6 : _ref6) || '',
          text: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.button_text : _ref5 : _ref5) || '',
          url: new UrlParse(((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.button_url) != null ? _ref4.url : _ref4 : _ref4 : _ref4) || '').pathname,
          tracking: {
            data: {
              event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
              event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
              event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
            }
          }
        }
      };
    }

  }
};